import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import Sidebar from "~/components/Sidebar/Sidebar.tsx";
import { quotaQueries } from "~/modules/quota/api/quota/quotaQueries.ts";
import type { QuotaWithRelations } from "~/modules/quota/api/quota/quotaTypes.ts";
import {
	UpdateQuotaConsumersForm,
} from "~/modules/quota/components/QuotaDetailsView/components/UpdateQuotaConsumersSidebar/UpdateQuotaConsumersForm.tsx";
import {
	getQuotaConsumerProjectIds,
	invalidateProjectQuotaQueries,
	invalidateQuotaQueries,
} from "~/modules/quota/utils/quotaCacheUtils.ts";

type Props = {
	isOpen: boolean;
	onClose: () => void;
	quota: QuotaWithRelations;
};

export const UpdateQuotaConsumersSidebar = ({ isOpen, onClose, quota }: Props) => {
	const queryClient = useQueryClient();

	const handleSuccess = useCallback(async () => {
		await invalidateQuotaQueries(queryClient);
		// The affected projects are the projects of the consumers before and after the change.
		const updatedQuota = queryClient.getQueryData(quotaQueries.details(quota.companyId, quota.id, true).queryKey);
		const updatedConsumers = updatedQuota && "consumers" in updatedQuota ? updatedQuota.consumers : [];
		invalidateProjectQuotaQueries(queryClient, getQuotaConsumerProjectIds([...quota.consumers, ...updatedConsumers]));
		onClose();
	}, [onClose, queryClient, quota.companyId, quota.consumers, quota.id]);

	return (
		<Sidebar closeOnOutsideClick={false}
				 open={isOpen}
				 width="xl"
				 setOpen={onClose}>
			{isOpen && <UpdateQuotaConsumersForm onCancel={onClose}
												 onSuccess={handleSuccess}
												 quota={quota} />}
		</Sidebar>
	);
};
